import {createRouter, createWebHistory} from "vue-router";
import Index from "@/pages/Index";
import Finances from "@/pages/Finances";
import Detailing from "@/pages/Detailing";
import Messages from "@/pages/Messages";
import Profile from "@/pages/Profile";
import NotFound from "@/pages/NotFound";
import ChangeTariff from "@/pages/ChangeTariff";
import MessageInner from "@/pages/MessageInner";
import Reservation from "@/pages/Reservation";
import ReservationRevoke from "@/pages/ReservationRevoke";
import ReservationSelect from "@/pages/ReservationSelect";
import Login from "@/pages/Login";
import Registration from "@/pages/Registration";
import Location from "@/pages/Location";
import PasswordRecovery from "@/pages/PasswordRecovery";
import TemporaryPassword from "@/pages/TemporaryPassword";
import Verification from "@/pages/Verification";
import Error from "@/pages/Error";
import Admin from "@/pages/Admin";
import Branches from "@/pages/Branches";
import PayResponse from "@/pages/PayResponse.vue";

const ifAuthenticated = (to, from, next) => {
    if (localStorage.getItem('access-token')) {
      next()
      return
    }
    next('/login')
}
const ifAdmin = (to, from, next) => {
    if (!!localStorage.getItem('is-staff')) {
        console.log(!!localStorage.getItem('is-staff'))
        next()
        return
    }
    next('/')
}

const routes = [
    {
        path: '/',
        name: 'home',
        meta: {layout: 'main-layout'},
        component: Index,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/finances',
        meta: {layout: 'main-layout'},
        component: Finances,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/detailing',
        meta: {layout: 'main-layout'},
        component: Detailing,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/messages',
        name: 'messages',
        meta: {layout: 'main-layout'},
        component: Messages,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/profile',
        meta: {layout: 'main-layout'},
        component: Profile,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/change-tariff',
        // redirect: '/',
        meta: {layout: 'main-layout'},
        component: ChangeTariff,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/reservation',
        redirect: '/',
        meta: {layout: 'main-layout'},
        component: Reservation,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/reservation-revoke',
        redirect: '/',
        meta: {layout: 'main-layout'},
        component: ReservationRevoke,
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/reservation-select',
        redirect: '/',
        meta: {layout: 'main-layout'},
        component: ReservationSelect,
        beforeEnter: ifAuthenticated,
    },
    { 
        path: '/message/:id', 
        meta: {layout: 'main-layout'},
        component: MessageInner,
        beforeEnter: ifAuthenticated,
    },
    { 
        path: '/login',
        meta: {layout: 'form-layout'}, 
        component: Login 
    },
    { 
        path: '/verification',
        meta: {layout: 'form-layout'}, 
        component: Verification 
    },
    { 
        path: '/registration',
        meta: {layout: 'form-layout'}, 
        component: Registration 
    },
    { 
        path: '/location',
        redirect: '/login',
        meta: {layout: 'form-layout'}, 
        component: Location 
    },
    { 
        path: '/password-recovery',
        meta: {layout: 'form-layout'}, 
        component: PasswordRecovery 
    },
    { 
        path: '/restore',
        meta: {layout: 'form-layout'}, 
        component: TemporaryPassword 
    },
    { 
        path: '/admin',
        meta: {layout: 'empty-layout'}, 
        component: Admin,
        beforeEnter: ifAuthenticated,
        beforeEnter: ifAdmin,
    },
    { 
        path: '/:pathMatch(.*)*', 
        name: '404',
        meta: {layout: 'main-layout'},
        component: NotFound,
        beforeEnter: ifAuthenticated,
    },
    { 
        path: '/branches',
        meta: {layout: 'main-layout'}, 
        component: Branches,
        beforeEnter: ifAuthenticated,
    },
    { 
        path: '/error/:type',
        meta: {layout: 'main-layout'}, 
        component: Error,
        beforeEnter: ifAuthenticated,
    },
    { 
        path: '/pay-response/:id',
        meta: {layout: 'main-layout'}, 
        name: 'pay-status',
        component: PayResponse,
        beforeEnter: ifAuthenticated,
    },
]

const router = createRouter({
    routes,
    history: createWebHistory(process.env.BASE_URL)
})

export default router;